import Api from 'app/services/Api';

export const resource = 'worker';

export function getAll(params) {
  return Api.get(resource, { params });
}
